/**
 * @module ConstructorIO/searchSuggestions
 */

import ConstructorIOClient from '@constructor-io/constructorio-client-javascript';
import config from '../config/config';
import {processProductSearchSuggestions, processTermsSearchSuggestions} from './helpers/result';

const mobileMQ = window.matchMedia(`(max-width: ${config.BREAKPOINTS.TABLET_MAX}px)`);

/**
 *  Class wrapping the Constructor.io search suggestions functionality.
 */
export default class ConstructorIOSearchSuggestions {
    #maxSuggestions = null;

    #maxTerms = null;

    #country = null;

    #filters = null;

    #client = null;

    #variations_map = null;

    constructor() {
        this.#client = new ConstructorIOClient({
            apiKey: window.CONSTRUCTOR_API_KEY,
            userId: window.customer.customerNo
        });

        this.#country = window.CURRENT_COUNTRY;
        // request 1 more product than we show in order to determine whether we should show the 'show more' link
        this.#maxSuggestions = (window.SitePreferences.SEARCH_SUGGESTION_COUNT || 5) + 1;

        if (mobileMQ.matches) {
            this.#maxTerms = window.Resources.CONSTRUCTOR_SUGGESTIONS_TERMS_MAX_COUNT_MOBILE || 3;
        } else {
            this.#maxTerms = window.Resources.CONSTRUCTOR_SUGGESTIONS_TERMS_MAX_COUNT || 6;
        }
        const filters = {};
        filters[`available_${window.Constants.SITE_ID}`] = 'True';
        this.#filters = filters;

        this.#variations_map = {
            values: {variation_ids: {aggregation: 'all', field: 'data.variation_id'}},
            dtype: 'array'
        };
    }

    /**
     * @param {string} searchQuery - query to execute search on
     * @returns {{products: Array<Object>|null}} suggestions or null
     */
    async getSuggestions(searchQuery) {
        try {
            if (!searchQuery) {
                return {
                    products: null
                };
            }
            const results = await this.#client.autocomplete.getAutocompleteResults(searchQuery, {
                resultsPerSection: {
                    Products: this.#maxSuggestions,
                    'Search Suggestions': this.#maxTerms
                },
                filters: this.#filters,
                variationsMap: this.#variations_map
            });

            if (results.sections.Products.length === 0) {
                return {
                    products: null,
                    terms: null
                };
            }

            const products = processProductSearchSuggestions(results.sections.Products);
            const terms = processTermsSearchSuggestions(results.sections['Search Suggestions']);

            return {
                products,
                terms
            };
        } catch (error) {
            console.error(error);
            return {
                products: null,
                terms: null
            };
        }
    }
}
